import {Component, createRef } from 'preact';
import { connect } from 'unistore/preact';
import style from './style.css';
import { onChange } from '../../../controller/theme_checkout';
import common from '../../../common/common';

class MerchantLogoSection extends Component {
  constructor(props) {
    super(props);
    // this.onMerchantLogoFileChange = this.onMerchantLogoFileChange.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.onRemoveLogoFile = this.onRemoveLogoFile.bind(this);
    this.onResetDefaultLogoClick = this.onResetDefaultLogoClick.bind(this);
    this.state = { 
      selectedFile: null, 
      showErrorMessage: false,
      imageUrl: null,
      enableLogo: false,
      imageUrlFromMapping: null
    };
  }

  merchantLogoFileRef = createRef();

  componentDidMount() {
    if(this.props.selected.merchant) {
      this.setState({
        imageUrlFromMapping: this.props.selected.merchant.merchantLogoUrl
      })
    }
  }

  onFileChange(event, logoFile) {
    
    if(!logoFile.type || 
      !(logoFile.type.includes('image/png') || logoFile.type.includes('image/jpeg')) || 
      logoFile.size > 3000000){
      console.log("invalid file")
      this.setState({
        ...this.state,
        showErrorMessage: true,
        enableLogo: false
      })
      event.preventDefault();
      return;
    }

    this.setState({
      ...this.state,
      showErrorMessage: false,
      selectedFile : logoFile,
      imageUrl: URL.createObjectURL(logoFile),
      enableLogo: true
    }, () => {
      const { onMerchantLogoChange } = this.props;
      onMerchantLogoChange && onMerchantLogoChange(logoFile, this.state.imageUrl)
    });
  }

  onRemoveLogoFile(){
    const { onMerchantLogoChange } = this.props;
    onMerchantLogoChange && onMerchantLogoChange(null, this.state.imageUrlFromMapping)

    this.setState({
      ...this.state,
      enableLogo: false,
      showErrorMessage: false,
      selectedFile: null
    });
  }

  onResetDefaultLogoClick() {
    const { onMerchantLogoChange } = this.props;

    fetch(`${common.getStaticPath()}/assets/images/merc-default.png`)
      .then(res => res.blob())
      .then(data => {
        let metadata = { type: 'image/png' }
        let file = new File([data], "merc-default.png", metadata)
        const defaultLogoUrl = URL.createObjectURL(file);

        // onMerchantLogoChange && onMerchantLogoChange(file, defaultLogoUrl)
        this.setState({
          ...this.state,
          showErrorMessage: false,
          selectedFile : file,
          imageUrl: defaultLogoUrl,
          enableLogo: true
        }, () => {
          onMerchantLogoChange && onMerchantLogoChange(file, defaultLogoUrl)
        });
      })

  }

  render({ selected }) {
    return (
      <div className={`${style['logo-upload-section']}`}>
        <h6 className={`${style['heading']} uppercase`}> Upload Brand Logo </h6>
        <div className={`${style['helper-text']}`}>
          <ul>
            <li><span>Max Size: 3MB</span></li>
            <li><span>Size: 80X40PX</span></li>
            <li><span>Format: JPG, JPEG, PNG</span></li>
          </ul>
        </div>

        <div className={`${style["upload-section"]} df`}>
          <div className={"upload-loader"} >
            {this.state.selectedFile ? (
              <div className={style["upload-logo"]}>
                <img className={style["selected-logo"]} src={this.state.imageUrl} alt={this.state.selectedFile ? this.state.selectedFile.name : ''} /> 
                  <img 
                    className={style["close-button"]} 
                    src={`${common.getStaticPath()}/assets/images/ic-clear.svg`}
                    alt="Clear"
                    onClick={this.onRemoveLogoFile}
                  />
                <span className={style["selected-logo-name"]}>{this.state.selectedFile.name}</span> 
              </div>
            ) : (
              <div className={`${style["button-container"]}`}>
                <div className={`${style["upload-button"]}`}>
                    <label className={`${style["upload-button-label"]}`} for="merchantLogoFileUpload">
                      <img src={`${common.getStaticPath()}/assets/images/upload.svg`} alt="Upload"/>
                    </label> 
                    <input
                      type='file'
                      accept="image/png, image/jpeg"
                      className={style["fileup"]}
                      id="merchantLogoFileUpload"
                      ref={this.merchantLogoFileRef}
                      onChange={(e) => {this.onFileChange(e, this.merchantLogoFileRef.current.files[0])}}
                    />
                </div>
                {!this.state.selectedFile && selected.merchant && selected.merchant.merchantLogoUrl && selected.merchant.merchantLogoUrl !== '' 
                  && selected.merchant.merchantLogoUrl.includes('http') 
                  && <div className={`${style["reset-button-container"]} right pos-r`} onClick={this.onResetDefaultLogoClick}>
                    Reset default logo
                  </div>}
              </div>
              
            )}
          </div>
        </div>
        {this.state.showErrorMessage && <div className={style["error"]}><strong>Error: File size or type not appropriate.</strong></div>}
      </div>
    );
  }
}

export default connect('selected', onChange)(MerchantLogoSection);



// WEBPACK FOOTER //
// ./checkout/components/merchantLogoSection/index.js